import React, { FC, MouseEvent } from 'react';
import Clickable from '@move-ui/clickable';

import { MaskedLink } from '@move-web-essentials-utils/masked-link';
import cx from 'classnames';

import styles from './AppStoreIcons.css';
import {
  AppStoreEnum,
  AppStoreItem,
  NavigationClickHandler
} from '../../types';
import { useTranslation } from '../../utils/translations';
import { ANDROID_APP_STORE_IMAGE, IOS_APP_STORE_IMAGE } from '../../config';

export type AppStoreIconsProps = {
  items?: AppStoreItem[];
  onClick?: NavigationClickHandler;
  classNames?: {
    root?: string;
    item?: string;
  };
};

const appStoreImages: Record<AppStoreEnum, string> = {
  [AppStoreEnum.AppStore]: IOS_APP_STORE_IMAGE,
  [AppStoreEnum.PlayStore]: ANDROID_APP_STORE_IMAGE
};

const AppStoreIcons: FC<AppStoreIconsProps> = ({
  items,
  onClick,
  classNames
}) => {
  const { translate } = useTranslation();

  const handleClick = (name: string, url: string) => (event: MouseEvent) => {
    onClick?.(name, { url }, event);
  };

  return (
    <div
      className={cx(styles.component, classNames?.root)}
      data-testid="AppStoreIcons"
    >
      {items?.map(({ name, label, url }) => {
        const localizedUrl = translate(url);

        return (
          <MaskedLink key={url} url={localizedUrl}>
            <Clickable
              className={cx(styles.clickContainer, classNames?.item)}
              onClick={handleClick(name, localizedUrl)}
            >
              <img
                src={appStoreImages[name as AppStoreEnum]}
                alt={translate(label)}
              />
            </Clickable>
          </MaskedLink>
        );
      })}
    </div>
  );
};

export default AppStoreIcons;
